import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityTaskListDetails = () => {
  const columns = [
    { label: 'Title', value: 'task' },
    { label: 'Due Date', value: (item) => fmtDate(item.due_date) },
    { label: 'Status', value: 'status' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/task/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityTask']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityTaskListDetails;